import React, {Component, createRef} from "react";
import PersonalDataBlock from "./PersonalDataBlock";
import ConsumptionBlock from "./ConsumptionBlock";
import LocationBlock from "./LocationBlock";

export default class Form extends Component {
    constructor() {
        super(...arguments);

        const options = JSON.parse(this.props.options);

        this.operator_grms = options.operator_grms;
        this.building_types = options.building_types;
        this.gas_devices = options.gas_devices;

        this.state = {
            application: {
                last_name: "",
                first_name: "",
                middle_name: "",
                ipn: "",
                email: "",
                phone_number: "",
                region_id: "",
                district_id: "",
                city_id: "",
                street_id: "",
                street_name_manual: "",
                building_number: "",
                apartment_number: "",
                postcode: "",
                operator_grm_id: "",
                building_type: "",
                eic: "56X",
                registered_persons: '',
                building_square: '',
                has_counter: '0',
                gas_devices: [],
            },
            acceptTerms: false,
            success: false,
            errors: {},
        }

        this.updateApplication = this.updateApplication.bind(this);
        this.updateErrors = this.updateErrors.bind(this);
        this.submit = this.submit.bind(this);
    }

    updateApplication(attr, value) {
        this.setState(prevState => ({
            application: {
                ...prevState.application,
                [attr]: value
            }
        }))
    }

    updateErrors(attr, value) {
        this.setState(prevState => ({
            errors: {
                ...prevState.errors,
                [attr]: value
            }
        }))
    }

    submit() {
        const {application} = this.state;
        let formData = new FormData();
        _.map(application, (value, key) => {
            formData.append(key, value ? value : '')
        });

        let gas_devices = [];
        _.map(application.gas_devices, (value, id) => {
            formData.append(`gas_devices[${id}]`, value.value);
        });

        axios.post('/application', formData)
            .then((res) => {
                this.setState({
                    success: true,
                    errors: {}
                }, () => {
                    window.scroll(0, 0);
                });
            })
            .catch((error) => {
                this.setState({
                    errors: error.response.data.errors || {},
                    error: error.response.data.errors[Object.keys(error.response.data.errors)[0]] || {}
                });
            })
    }

    render() {
        const {application, acceptTerms, success, errors} = this.state;

        return (
            <div>
                <h3 className="text-center font-weight-bolder">Заявка на приєднання</h3>
                {success &&
                <div className="alert alert-success" role="alert">
                    Заявка успішно подана! <a href="/documents">Перейти до завантаження документів</a>.
                </div>
                }
                <PersonalDataBlock
                    onChange={this.updateApplication}
                    first_name={application.first_name}
                    last_name={application.last_name}
                    middle_name={application.middle_name}
                    ipn={application.ipn}
                    email={application.email}
                    phone_number={application.phone_number}
                    errors={errors}
                    updateErrors={this.updateErrors}
                />
                <ConsumptionBlock
                    onChange={this.updateApplication}
                    operator_grms={this.operator_grms}
                    building_types={this.building_types}
                    gas_devices_op={this.gas_devices}
                    eic={application.eic}
                    operator_grm_id={application.operator_grm_id}
                    building_type={application.building_type}
                    gas_devices={application.gas_devices}
                    registered_persons={application.registered_persons}
                    building_square={application.building_square}
                    has_counter={application.has_counter}
                    errors={errors}
                    updateErrors={this.updateErrors}
                />
                <LocationBlock
                    onChange={this.updateApplication}
                    region_id={application.region_id}
                    district_id={application.district_id}
                    city_id={application.city_id}
                    street_id={application.street_id}
                    street_name_manual={application.street_name_manual}
                    postcode={application.postcode}
                    building_number={application.building_number}
                    apartment_number={application.apartment_number}
                    errors={errors}
                />

                {this.state.error &&
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    {this.state.error}
                    <button type="button" className="close" onClick={() => {this.setState({error: ''})}}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                }

                <div className="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id="accept_terms"
                        value={acceptTerms}
                        onChange={(e) => this.setState({acceptTerms: e.target.checked})}
                    />
                    <label className="custom-control-label" htmlFor="accept_terms">Приймаю умови обробки даних</label>
                </div>

                <button className="btn btn-primary my-4" type="button"
                        onClick={this.submit}
                        disabled={!acceptTerms || success}
                >
                    Продовжити
                </button>
            </div>
        )
    }
}
